<template>
  <span class="action-item" :class="'action-item--' + position">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'ActionItem',
  props: {
    position: {
      type: String,
      default: 'left',
      validator: val => ['left', 'right'].includes(val)
    }
  }
}
</script>
